<template>
  <div class="p-4">ClientContabilidadAsientos</div>
</template>

<script>
export default {
  name: 'ClientContabilidadAsientos'
}
</script>
